import TOCJourneyPresenter from "@adapters/features/TOCJourney/Presenters/TOCJourney";
import MandateFlowPresenter from "@adapters/features/MandateFlow/Presenter/MandateFlow";
import PaymentFlowPresenter from "@adapters/features/PaymentFlow/Presenters/PaymentFlowPresenter";
import { accountDetails } from "../../../../../../mainDi/webDi";
export default (function (useCases, actions) {
    return {
        tocJourney: new TOCJourneyPresenter(useCases.tocJourney, actions.tocJourney, accountDetails, useCases.quoteStream),
        mandate: new MandateFlowPresenter(useCases.mandate),
        payment: new PaymentFlowPresenter(useCases.payment),
    };
});
